<template>
    <div class="billingContainer">
        <div class="header">
            <div class="heading">
                <p class="title">Billing</p>
            </div>
        </div>
        <div class="paymentContainer">
            <div v-if="(this.apiErrorMessage)" class="errorContainer"> 
                <div  class="errorHeading" ><img alt="img" src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.apiErrorMessage }}</div>
            </div>
            <div v-else-if="(this.apiSuccessMessage)" class="errorContainer successContainer">
                <div  class="errorHeading successHeading" ><img alt="img" src="../assets/greenTick.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.apiSuccessMessage }}</div>
            </div>
            <div v-if="this.role === 'OPS' || this.role === 'SUPERADMIN'" class="buttons"> 
                <div class="btnWrap"> 
                    <label for="uploadCreditDetails">Upload Credit Limits</label>
                    <input type="file" name="uploadCreditDetails" class="btn advReports" @click="onInputClick" @change="onUploadCreditDetailsBtnClick" />
                    <div class="uploadBtn" @click="onUploadCreditClick">Upload</div>
                </div>

                <div class="btnWrap"> 
                    <label for="uploadCreditDetails">Upload Payment Details</label>
                    <input type="file" name="uploadRechargeDetails" class="btn savedReports" @click="onInputClick" @change="onUploadRechargeDetailsBtnClick" />
                    <div class="uploadBtn" @click="onUploadRechargeClick">Upload</div>
                </div>

                <div class="btnWrap"> 
                    <label for="uploadPromotionalCredit">Upload Promotional credits</label>
                    <input type="file" name="uploadPromotionalCredit" class="btn savedReports" @click="onInputClick" @change="onUploadPromotionalCreditBtnClick" />
                    <div class="uploadBtn" @click="onUploadPromotionalCreditClick">Upload</div>
                </div>

            </div>
            <div v-if="this.role === 'OPS' || this.role === 'SUPERADMIN'" class="reports">Reports</div>
            <div v-if="this.role === 'OPS' || this.role === 'SUPERADMIN'" class="buttons"> 
            
                <div class="btnWrap" style="margin-bottom: unset"> 
                    <label for="uploadPromotionalCredit" style="max-width: unset">Generate Credit limits report</label>
                    <div class="uploadBtn" @click="onDownloadCreditsLimit">Download</div>
                </div>
                <div class="btnWrap" style="margin-bottom: unset"> 
                    <label for="uploadPromotionalCredit" style="max-width: unset">Generate Promotional Credits report</label>
                    <div class="uploadBtn" @click="onDownloadPromotionalCredit">Download</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { uploadCreditDetails, uploadRechargeDetails, uploadPromotionalCredit,
    getCookie, downloadCreditReport, downloadPromotionalCreditReport } from '../services/campaignService'

export default {
    name: 'Billing',
   data(){
    return{
        creditDetailsFile: null,
        rechargeDetailsFile: null,
        apiErrorMessage: null,
        apiSuccessMessage: null,
        promotionalCreditFile: null,
        role: '',
    }
   },
    mounted() {
        this.role = getCookie('role');
    },
   methods: {
    onDownloadCreditsLimit(){
        downloadCreditReport();
    },
    onDownloadPromotionalCredit(){
        downloadPromotionalCreditReport();
    },
    onInputClick(){
        this.apiErrorMessage = null;
        this.apiSuccessMessage = null;
    },
    onUploadPromotionalCreditClick(){
        if(this.promotionalCreditFile){
            const formData = new FormData();
            formData.append('file', this.promotionalCreditFile);
            uploadPromotionalCredit(formData)
            .then(res=>{
                if(res?.status === 400){
                    this.apiErrorMessage = 'Invalid file. Please upload a valid file.'
                }else if(res?.status === 200 || res?.status === 201){
                    const ele = document.getElementsByName('uploadPromotionalCredit')[0];
                    ele.value = ""
                    this.promotionalCreditFile = null;
                    this.apiErrorMessage = null;
                    this.apiSuccessMessage = 'Promo Credit Details Saved Successfully'
                    return res.json()
                } else {
                    this.apiErrorMessage = 'Server error.'
                }
            })
        }
    },
    onUploadCreditClick(){
        if(this.creditDetailsFile){
            const formData = new FormData();
            formData.append('file', this.creditDetailsFile);
            uploadCreditDetails(formData)
            .then(res=>{
                if(res?.status === 400){
                    this.apiErrorMessage = 'Invalid file. Please upload a valid file.'
                }else if(res?.status === 200 || res?.status === 201){
                    const ele = document.getElementsByName('uploadCreditDetails')[0];
                    ele.value = ""
                    this.creditDetailsFile = null;
                    this.apiErrorMessage = null;
                    this.apiSuccessMessage = 'Credit Limit successfully uploaded'
                    return res.json()
                } else {
                    this.apiErrorMessage = 'Server error.'
                }
            })
        }
    },
    onUploadRechargeClick(){
        if(this.rechargeDetailsFile){
            const formData = new FormData();
            formData.append('file', this.rechargeDetailsFile);
            uploadRechargeDetails(formData)
            .then(res=>{
                if(res?.status === 400){
                    this.apiErrorMessage = 'Invalid file. Please upload a valid file.'
                }else if(res?.status === 200 || res?.status === 201){
                    const ele = document.getElementsByName('uploadRechargeDetails')[0];
                    ele.value = ""
                    this.rechargeDetailsFile = null;
                    return res.json()
                }else {
                    this.apiErrorMessage = 'Server error.'
                }
            })
            .then(data => {
                if(data?.message === 'failure'){
                    if(data?.invalidSellerIds?.length !== 0 && data?.invalidTransactions?.length !== 0){
                        this.apiErrorMessage = `Invalid seller IDs : ${data?.invalidSellerIds}, Invalid Transactions : ${data?.invalidTransactions}`
                    }else if(data?.invalidSellerIds?.length !== 0){
                        this.apiErrorMessage = `Invalid seller IDs : ${data?.invalidSellerIds}`
                    }else if(data?.invalidTransactions?.length !== 0){
                        this.apiErrorMessage = `Invalid Transactions : ${data?.invalidTransactions}`
                    }
                }else if(data?.message === 'success'){
                    this.apiErrorMessage = null;
                    this.apiSuccessMessage = 'Payment Details successfully updated';
                }
            })
        }
    },
    onUploadPromotionalCreditBtnClick(event){
        this.apiErrorMessage = null;
        this.apiSuccessMessage = null;
        this.promotionalCreditFile = event.target.files[0]
    },
    onUploadCreditDetailsBtnClick(event){
        this.apiErrorMessage = null;
        this.apiSuccessMessage = null;
        this.creditDetailsFile = event.target.files[0]
        // const formData = new FormData();
        // formData.append('file', this.creditDetailsFile);
        // uploadCreditDetails(formData)
    },
    onUploadRechargeDetailsBtnClick(event){
        this.apiErrorMessage = null;
        this.apiSuccessMessage = null;
        this.rechargeDetailsFile = event.target.files[0];
        // const formData = new FormData();
        // formData.append('file', this.rechargeDetailsFile);
        // uploadRechargeDetails(formData)
    }
   }
}
</script>

<style scoped>

.reports{
    padding: 14px 10px;
    margin: 12px 16px 8px 16px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.01em;
    color: #666666;
}
.btnWrap{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}
.errorContainer{
    background: #FDEDED;
    border-radius: 8px;
    margin: 2%;
    margin-bottom: unset;
    padding: 18px 24px;
    font-family: 'Inter-Regular';
    font-style: normal;
    margin: 12px 16px 8px 16px;
}

.successContainer{
    background-color: #DFF2BF;
}

.successHeading{
    color: #270 !important;
}

.errorHeading{
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #EB5757;
    /* margin-bottom: 12px; */
    display: flex;
}

.apiErrorMessage{
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #666666;
    margin-top: 12px;
}
.buttons{
    padding: 14px 10px;
    background: #F8F8F8;
    border-radius: 4px;
    margin: 12px 16px 8px 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    max-width: 1240px;
}

label{
    margin-right: 10px;
    max-width: 162px;
}

.btn{
    cursor: pointer;
    opacity: 0.8;
    font-size: 14px;
    font-weight: 500;
    line-height: 23px;
    padding: 6px 12px;
    text-align: center;
    color: #0004B5;
    border-radius: 4px;
    width: fit-content;
    height: fit-content;
    margin-right: 24px;
    border: 1px solid #2E31BE;
    cursor: pointer;
}

.uploadBtn{
    cursor: pointer;
    background: #2E31BE;
    border-radius: 4px;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
    color: #FFFFFF;
    width: 80px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 24px;
}
.billingContainer {
    font-family: 'Inter-Regular';
    background: #F8F8F8;
    display: flex;
    flex-direction: column;
}
.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-family: 'Inter-Regular';
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    color: #401D0C;
    padding: 8px 20px 0px;
    margin-left: 0;
    background: #FFFFFF;
}
.title{
    margin-left:20px;
}
.heading {
    display: flex;
    flex-direction: row;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    color: #333333;
    margin: 0;
}
.paymentContainer {
    display: flex;
    flex-direction: column;
    margin: 1%;
    text-align: start;
    background: #FFFFFF;
    padding: 22px 24px 36px;
    border-radius: 12px;
}
</style>